import ApiService from "@/core/services/api.service";

export const PATH_EXAM_SCHEDULE = "academic/marking/exam-schedule"
export const GET_LIST_EXAM_SCHEDULE = "GET_LIST_EXAM_SCHEDULE"
export const CREATE_EXAM_SCHEDULE = "CREATE_EXAM_SCHEDULE"
export const DELETE_EXAM_SCHEDULE = "DELETE_EXAM_SCHEDULE"
export const PATH_RETEST = "academic/marking/exam-retake"
export const PATH_ENTRANCE_RETEST_SCHEDULE = "academic/marking/schedule-exam-first-course"
export const PATH_CREATE_ENTRANCE_RETEST = "academic/marking/exam-retake/retest-entrance-exam"
export const GET_LIST_RETEST = "GET_LIST_RETEST"
export const GET_DETAILS_RETEST = "GET_DETAILS_RETEST"
export const UPDATE_RETEST = "UPDATE_RETEST"
export const CREATE_RETEST = "CREATE_RETEST"
export const GET_ENTRANCE_RETEST_SCHEDULE = "GET_ENTRANCE_RETEST_SCHEDULE"
export const CREATE_ENTRANCE_RETEST = "CREATE_ENTRANCE_RETEST"
export const DELETE_RETEST = "DELETE_RETEST"
export const GET_SKILLS_RETEST = "academic/marking/skills"
export const GET_ALL_EXAM_SCHEDULE = "GET_ALL_EXAM_SCHEDULE"
export const GET_COURSES_ACTIVE_BY_USER = "academic/marking/course-in-progress"
export const GET_CLASS_ACTIVE_BY_USER = "academic/marking/classes-in-progress"
export const GET_ALL_ADMIN_TEST = "academic/admin/all"
export const GET_MANAGE_TASK_LIST = "academic/academic-task/coordinator"
export const ASSIGN_ADMIN_TASK = "academic/academic-task/assign-admin"
export const UPDATE_PERSON_IN_CHARGE = "UPDATE_PERSON_IN_CHARGE"
export const GET_DETAIL_TASK = "GET_DETAIL_TASK"
export const RESET_CHEATING = "academic/marking/reset-cheating"
export const HANDLE_CHEATING_TASK = "academic/academic-task/cheating/handle"
export const GET_SCORE_RESULT = "GET_SCORE_RESULT"
export const GET_GRADING_TYPES = "academic/submissions/grading-types";
export const GET_ENTRANCE_EXAM_RESULT = "GET_ENTRANCE_EXAM_RESULT";
// Xử lý lỗi thanh toán (đánh dấu đã nhận tiền thủ công)
export const HANDLE_RETEST_ERROR_PAYMENT = "HANDLE_RETEST_ERROR_PAYMENT"
export const PATH_HANDLE_RETEST_ERROR_PAYMENT = "audit/report-payments"

/**
 * Chuẩn hóa response POST/PUT exam-retake: luôn có `data: { retake, payment }` (payment có thể null),
 * đồng thêm `retake` / `payment` ở root để đọc nhanh. Giữ nguyên khi `error === true`.
 */
export function normalizeExamRetakeWriteResponse(raw) {
    if (raw == null || typeof raw !== "object") return raw;
    if (raw.error === true) return raw;

    if (raw.retake != null && Object.prototype.hasOwnProperty.call(raw, "payment")) {
        return {
            ...raw,
            data: {retake: raw.retake, payment: raw.payment},
        };
    }

    const inner = raw.data;
    if (inner == null || typeof inner !== "object") return raw;

    if (inner.retake != null && Object.prototype.hasOwnProperty.call(inner, "payment")) {
        return {
            ...raw,
            retake: inner.retake,
            payment: inner.payment,
            data: {retake: inner.retake, payment: inner.payment},
        };
    }

    const payment = inner.payment ?? null;
    return {
        ...raw,
        retake: inner,
        payment,
        data: {retake: inner, payment},
    };
}

const state = {};

const getters = {};

const actions = {
    [GET_LIST_EXAM_SCHEDULE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${PATH_EXAM_SCHEDULE}`, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [CREATE_EXAM_SCHEDULE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(PATH_EXAM_SCHEDULE, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [DELETE_EXAM_SCHEDULE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${PATH_EXAM_SCHEDULE}`, payload.id).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_LIST_RETEST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${PATH_RETEST}`, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_SCORE_RESULT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${PATH_RETEST}/${payload.id}/result`).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_ENTRANCE_EXAM_RESULT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query('academic/submissions/result-entrance-exam', payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_DETAILS_RETEST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${PATH_RETEST}/${payload.id}`).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [HANDLE_RETEST_ERROR_PAYMENT](context, payload) {
        return new Promise((resolve, reject) => {
            const id = payload?.id ?? payload?.payment_id ?? null
            const amount_paid = payload?.amount_paid ?? payload?.amount ?? null
            const body = {amount_paid}
            if (payload?.type) body.type = payload.type
            ApiService.post(`${PATH_HANDLE_RETEST_ERROR_PAYMENT}/${id}/process-payment-error`, body).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [CREATE_RETEST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(PATH_RETEST, payload).then(({data}) => {
                resolve(normalizeExamRetakeWriteResponse(data));
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_ENTRANCE_RETEST_SCHEDULE]() {
        return new Promise((resolve, reject) => {
            ApiService.query(PATH_ENTRANCE_RETEST_SCHEDULE).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [CREATE_ENTRANCE_RETEST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(PATH_CREATE_ENTRANCE_RETEST, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [UPDATE_RETEST](context, payload) {
        return new Promise((resolve, reject) => {
            console.log(payload)
            ApiService.put(`${PATH_RETEST}/${payload.id}`, payload).then(({data}) => {
                resolve(normalizeExamRetakeWriteResponse(data));
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [DELETE_RETEST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${PATH_RETEST}`, payload.id).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_SKILLS_RETEST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${GET_SKILLS_RETEST}`, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_ALL_EXAM_SCHEDULE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${PATH_EXAM_SCHEDULE}/all`, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_CLASS_ACTIVE_BY_USER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${GET_CLASS_ACTIVE_BY_USER}`, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_COURSES_ACTIVE_BY_USER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${GET_COURSES_ACTIVE_BY_USER}`, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_ALL_ADMIN_TEST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${GET_ALL_ADMIN_TEST}`, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_MANAGE_TASK_LIST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${GET_MANAGE_TASK_LIST}`, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [UPDATE_PERSON_IN_CHARGE](context, payload) {
        const { taskId, ...newPayload } = payload;
        return new Promise((resolve, reject) => {
            ApiService.put(`academic/academic-task/${taskId}`, newPayload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [ASSIGN_ADMIN_TASK](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(ASSIGN_ADMIN_TASK, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_DETAIL_TASK](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.query(`academic/academic-task/${id}`).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [RESET_CHEATING](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${RESET_CHEATING}`, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [HANDLE_CHEATING_TASK](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(HANDLE_CHEATING_TASK, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_GRADING_TYPES](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${GET_GRADING_TYPES}`, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
};


const mutations = {};

export default {
    state,
    actions,
    mutations,
    getters
};
